'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.refreshIfModified = exports.fetchBoard = exports.fetchBoards = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Utils


// Actions


// Selectors


// Constants


var _lodash = require('lodash');

var _http = require('../../utils/services/http');

var _http2 = _interopRequireDefault(_http);

var _resources = require('../../utils/services/http/resources');

var _resources2 = _interopRequireDefault(_resources);

var _elementHelper = require('../../../common/elements/elementHelper');

var _resourceUtil = require('../../utils/services/http/resources/resourceUtil');

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _logger = require('../../utils/logger');

var _logger2 = _interopRequireDefault(_logger);

var _elementActions = require('../../element/elementActions');

var _mainSelector = require('../../workspace/main/mainSelector');

var _boardSelector = require('./boardSelector');

var _resourceConstants = require('../../utils/services/http/resources/resourceConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var boardsResourceService = (0, _resources2.default)(_resourceConstants.RESOURCE_TYPES.boards);

/**
 * Fetches multiple boards in one go, based on the boardIds passed through in the argument object.
 * But only fetches them if they aren't already being fetched.
 */
var fetchBoards = exports.fetchBoards = function fetchBoards(args) {
    return function (dispatch, getState) {
        var boardIds = args.boardIds,
            force = args.force,
            loadAncestors = args.loadAncestors,
            excludeSelf = args.excludeSelf;


        var state = getState();
        var elements = state.get('elements');
        var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);

        var getBoardResource = (0, _immutableHelper.propFrom)(boardResourcesState);
        var boardResources = boardIds.map(getBoardResource);

        // If we are not forcing the fetch, and we have the board, and it has been fetched or it is fetching
        // then we don't need to fetch it again
        var boardIdsToFetch = boardIds.filter(function (boardId) {
            return !!boardId;
        }).filter(function (boardId) {
            return (0, _resourceUtil.shouldFetchResource)(force, getBoardResource(boardId));
        });

        // TODO This should potentially use the elements resources instead
        var shouldExcludeSelf = boardResources.reduce(function (exclude, board) {
            return exclude && ((0, _resourceUtil.isFetched)(board) || (0, _resourceUtil.isFetching)(board));
        }, excludeSelf);

        if (!boardIdsToFetch.length) {
            return Promise.resolve();
        }

        // Get the current children of the board to compare after the fetch and find out what's been deleted
        var initialChildIdsByParentIds = boardIdsToFetch.reduce(function (map, boardId) {
            map[boardId] = (0, _elementHelper.getChildIdsDeep)(elements, boardId);
            return map;
        }, {});

        var config = {
            timeout: 30000,
            retry: 1,
            storeServerErrors: false,
            params: {
                excludeSelf: shouldExcludeSelf,
                loadAncestors: loadAncestors
            }
        };

        return boardsResourceService({ dispatch: dispatch, config: config, ids: boardIdsToFetch }).then(function (response) {
            if (!(0, _lodash.size)(response.data.elements)) return response;

            // Figure out the difference between the fetched elements and previous elements
            // The remaining will need to be deleted
            var retrievedChildIds = (0, _lodash.keys)(response.data.elements);
            var deletedElementIds = boardIdsToFetch.reduce(function (deletedIdList, boardId) {
                if (!response.data.childrenReturned[boardId]) return deletedIdList;
                var initialChildIds = initialChildIdsByParentIds[boardId];
                var deletedIds = (0, _lodash.difference)(initialChildIds, retrievedChildIds);
                return deletedIdList.concat(deletedIds);
            }, []);

            dispatch((0, _elementActions.loadElements)(response.data.elements, deletedElementIds));
            return response;
        });
    };
};

var fetchNextBoards = function fetchNextBoards(boardId) {
    return function (dispatch, getState) {
        var state = getState();
        var elements = state.get('elements');
        var getBoard = (0, _immutableHelper.propFrom)(elements);

        var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);
        var getBoardResource = (0, _immutableHelper.propFrom)(boardResourcesState);

        var ancestorAndChildrenIds = (0, _mainSelector.getCurrentChildrenDeep)(state, { currentBoardId: boardId }).keySeq().toArray().concat((0, _mainSelector.getBreadcrumb)(state, { currentBoardId: boardId }).path);

        // Fetch any ancestor or child which:
        // - doesn't exist, or
        // - is a board or alias and hasn't been fetched yet
        var nextBoardsToFetch = ancestorAndChildrenIds.map(function (elementId) {
            var el = getBoard(elementId);
            return !el ? elementId : (0, _elementHelper.getPhysicalId)(el);
        }).filter(function (elementId) {
            return (0, _resourceUtil.shouldFetchResource)(false, getBoardResource(elementId));
        });

        return dispatch(fetchBoards({ boardIds: nextBoardsToFetch, excludeSelf: true, loadAncestors: false }));
    };
};

/**
 * Fetches the board and its children from the server if required.
 * If the board has already been fetched from the server then it will not be re-fetched, unless it is 'forced' to.
 *
 * @param boardId {String} The boardId of the board to fetch from the server.
 * @param force {Boolean} (Optional) If true this will
 *
 * @return {Promise} A promise resolved when the data has been retrieved.
 */
var fetchBoard = exports.fetchBoard = function fetchBoard(args) {
    return function (dispatch, getState) {
        var boardId = args.boardId,
            force = args.force,
            loadNextBoards = args.loadNextBoards,
            loadAncestors = args.loadAncestors,
            excludeSelf = args.excludeSelf;


        if (!boardId) {
            return Promise.reject('ERROR: boardService.fetchBoard: "boardId" must be provided');
        }

        var state = getState();
        var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);
        var boardResource = boardResourcesState.get(boardId);

        // If we shouldn't fetch the board then resolve immediately after fetching the next boards
        if (!(0, _resourceUtil.shouldFetchResource)(force, boardResource)) {
            if (loadNextBoards) dispatch(fetchNextBoards(boardId));
            return Promise.resolve();
        }

        // Get the current children of the board to compare after the fetch and find out what's been deleted
        var elements = state.get('elements');
        var initialChildIds = (0, _elementHelper.getChildIdsDeep)(elements, boardId);

        var config = {
            timeout: 15000,
            retry: 1,
            params: {
                loadAncestors: loadAncestors,
                excludeSelf: excludeSelf
            }
        };

        return boardsResourceService({ dispatch: dispatch, config: config, id: boardId }).then(function (response) {
            if (!(0, _lodash.size)(response.data.elements)) return response;

            // If the children have been returned for a board, then delete children that were initially there but are
            // no longer
            var childrenReturned = response.data.childrenReturned;
            var deletedElementIds = childrenReturned && (0, _lodash.difference)(initialChildIds, (0, _lodash.keys)(response.data.elements));

            dispatch((0, _elementActions.loadElements)(response.data.elements, deletedElementIds));
            if (loadNextBoards) dispatch(fetchNextBoards(boardId));
            return response;
        });
    };
};

var getModified = function getModified(boardId) {
    return (0, _http2.default)({ url: 'boards/' + boardId + '/modified', timeout: 1000 }).then(function (response) {
        return response.data.modifiedTime;
    }).catch(function (err) {
        console.error('ERROR: fetching board modified time', err, err.response);
        // Getting the modified time isn't overly important, so just return null and it will
        // automatically refresh this element
        return null;
    });
};

var refreshIfModified = exports.refreshIfModified = function refreshIfModified(args) {
    return function (dispatch, getState) {
        return getModified(args.boardId).then(function (modifiedTime) {
            var state = getState();
            var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);
            var boardFetchedTime = boardResourcesState.getIn([args.boardId, 'fetchedTime']);

            if (!boardFetchedTime) _logger2.default.warn('Board \'' + args.boardId + '\' does not have a fetched time');

            if (!modifiedTime || modifiedTime > boardFetchedTime) {
                return dispatch(fetchBoard(_extends({}, args, { force: true })));
            }

            return Promise.resolve(true);
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/boardService.js
// module id = 167
// module chunks = 0